abstract class DashboardWidget {
  readonly key: number | string;

  constructor(
    key: number | string,
    readonly x: number,
    readonly y: number,
    readonly width: number,
    readonly height: number,
    readonly displayType: string, // TODO
    readonly unit = 1,
  ) {
    this.key = Number(key); // int, uniquely identifies this widget among the widgets on the dashboard
  }

  abstract equals(w: DashboardWidget): boolean;
}

export default DashboardWidget;
